const BusinessType = {
  SoleProprietorship: "Sole Proprietorship",
  Corporation: "Corporation",
  Partnership: "Partnership",
};

export default BusinessType;
